import { Clock } from "lucide-react";
import { relativeTime, activityDotColor } from "./chatCardUtils";
import type { ActivityEvent } from "./chatCardUtils";

const MAX_VISIBLE = 10;

interface ActivityTimelineCardProps {
  events: ActivityEvent[];
}

export function ActivityTimelineCard({ events }: ActivityTimelineCardProps) {
  if (!events.length) return null;

  const visible = events.slice(0, MAX_VISIBLE);

  return (
    <div className="mt-2 space-y-2">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5 text-[11px] font-medium text-muted uppercase tracking-wider">
          <Clock size={12} />
          <span>Recent Activity</span>
        </div>
        <span className="text-[10px] text-muted">
          {events.length} event{events.length !== 1 ? "s" : ""}
        </span>
      </div>

      {/* Timeline */}
      <div className="space-y-0.5">
        {visible.map((event) => (
          <div
            key={event.id}
            className="flex items-start gap-2 rounded-md bg-card px-2.5 py-1.5"
          >
            <div
              className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${activityDotColor(event.type)}`}
            />
            <div className="flex-1 min-w-0">
              <span className="text-[11px] text-primary">
                {event.title || event.description}
              </span>
              {event.actor?.name && (
                <span className="text-[10px] text-muted ml-1">
                  by {event.actor.name}
                </span>
              )}
            </div>
            <span className="shrink-0 text-[10px] text-muted">
              {typeof event.timestamp === "number"
                ? relativeTime(event.timestamp)
                : event.timestamp.toLocaleDateString()}
            </span>
          </div>
        ))}
      </div>

      {events.length > MAX_VISIBLE && (
        <span className="text-[10px] text-muted">
          +{events.length - MAX_VISIBLE} more events
        </span>
      )}
    </div>
  );
}
